import {BaseLinkParams} from "../../../infrastructure/models/link/base-link-params";

export class BolaoLinkParams extends BaseLinkParams  {
  id: Number;
  filter: String;

  constructor(filter: String, id: Number) {
    super();

    this.id = id;
    this.filter = filter;
  }
}
